export default __webpack_public_path__ + "static/logo-3b961c34a74af249327fb5032d6e9826.svg";